import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, map } from 'rxjs/operators';

import * as fromStore from '../store';
import { Observable, combineLatest, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KlaviyoGuard {
  private store = inject(Store);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checkStore(route).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(route: ActivatedRouteSnapshot): Observable<boolean> {
    return combineLatest([
      this.store.select(fromStore.getCustomerLoaded),
      this.store.select(fromStore.getKlaviyoSubscribedProductIdsLoaded),
      this.store.select(fromStore.getCustomerAccessToken),
    ]).pipe(
      tap(([customerLoaded, loaded, token]) => {
        if (!loaded && ((customerLoaded && token) || token == undefined)) {
          this.store.dispatch(fromStore.LoadKlaviyoSubscribedProductIds());
        }
      }),
      map(([customerLoaded, loaded, token]) => loaded),
      filter(loaded => loaded),
      take(1)
    );
  }
}
